import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuthServiceProvider } from '../../api/auth'

const AuthService = AuthServiceProvider()
const name = 'getRoles'

export default () => (asyncAction(
  name,
  AuthService.getRoles
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/auth/getRoles.js